import React from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import HomeDefault from '../../../../../../components/HomeDefaultComponent';
import { translate } from '../../../../../../utils/util';

const Home = () => {
    const menu = () => {
        return [
            { route: 'cad', icon: 'mdi mdi-plus-box-outline', text: translate('insert-qrCodeCall', 'qrcode-picking') },
            { route: 'list', icon: 'mdi mdi-clipboard-list-outline', text: translate('list-qrCodeCall', 'qrcode-picking') },
        ];
    };

    return (
        <HomeDefault menu={menu()} title={{ icon: "mdi mdi-qrcode", label: translate('picking.qrCodeCall', 'expedition') }} sub />
    );
};

export default withRouter(withTranslation()(Home));
